import { fuseFilter, nullOrUndefined } from '@/plugins/fuse'
import { SSharedList } from '@/services/shared'
import QUERY from 'lodash'

export default {
  data () {
    return {
      fetching: {
        productGroups: false
      },
      options: {
        productGroups: []
      },
      selected: {
        productGroup: ''
      },
      editable: {
        productGroup: ''
      }
    }
  },

  methods: {
    async getProductGroups (context, search = '') {
      const selectedContext = context?.selected
      const fetchingContext = context?.fetching
      const optionsContext = context?.options

      if (nullOrUndefined(selectedContext) || nullOrUndefined(fetchingContext) || nullOrUndefined(optionsContext)) {
        throw Error('Invalid context object')
      }

      const selected = context.selected?.productGroup
      const fetching = context.fetching?.productGroups
      const options = context.options?.productGroups

      if (nullOrUndefined(selected) || nullOrUndefined(fetching) || nullOrUndefined(options)) {
        throw Error('Invalid context object')
      }

      context.fetching.productGroups = true
      context.selected.productGroup = ''

      const filters = {
        filter_text: search
      }

      return await SSharedList.getProductGroups(filters).then(
        ({ data }) => {
          context.options.productGroups = data
        }
      ).catch(() => {
        context.options.productGroups = []
      }).finally(() => {
        context.fetching.productGroups = false
      })
    },

    async searchProductGroups (search, loading) {
      this.searchProductGroupsProvider(this, search, loading)
    },

    searchProductGroupsProvider: QUERY.debounce(
      ({ options }, search, loading) => {
        const filteredOptions = fuseFilter(search, options.productGroups, {
          keys: ['group_name']
        })

        if (filteredOptions.length < 1) {
          loading(true)

          const filters = {
            filter_text: search
          }

          SSharedList.getProductGroups(filters).then(
            ({ data }) => {
              options.productGroups = data
            }
          ).catch(() => {
            options.productGroups = []
          }).finally(() => {
            loading(false)
          })
        }
      },
      500
    )
  }
}
